import { useUpdateStore } from '@/stores/updateStore';
import { openStorePage } from '@/version/updateCheck';
import { useT } from '@/i18n/useI18n';

/**
 * App-version gate. 'hard' blocks the app until the user updates (no dismiss);
 * 'soft' is a dismissible nudge. Driven by updateStore, which is set by
 * runUpdateCheck() on launch. Native only — web never triggers a gate.
 */
export function UpdateGateModal() {
  const gate = useUpdateStore((s) => s.gate);
  const dismissSoft = useUpdateStore((s) => s.dismissSoft);
  const t = useT();

  if (gate === 'none') return null;
  const hard = gate === 'hard';

  return (
    <div
      className="responsive-modal"
      onClick={hard ? undefined : dismissSoft}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.78)',
        backdropFilter: 'blur(6px)',
        zIndex: 700,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: 'max(env(safe-area-inset-top, 0px), 18px) 18px max(env(safe-area-inset-bottom, 0px), 18px)',
      }}
    >
      <div
        className="responsive-modal__card"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: 360,
          background: 'rgba(15,18,32,0.98)',
          border: '1px solid var(--hairline)',
          borderRadius: 16,
          padding: 22,
          boxShadow: '0 16px 48px rgba(0,0,0,0.5)',
          animation: 'cd-toast-in 0.25s ease-out',
        }}
      >
        <div
          className="display"
          style={{ fontSize: 18, letterSpacing: '0.05em', color: 'var(--c-cyan)', marginBottom: 8 }}
        >
          {t(hard ? 'update.hard_title' : 'update.soft_title')}
        </div>
        <div style={{ fontSize: 13, color: 'var(--ink-muted)', lineHeight: 1.45, marginBottom: 18 }}>
          {t(hard ? 'update.hard_body' : 'update.soft_body')}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button className="btn btn-primary" onClick={() => void openStorePage()}>
            {t('update.cta')}
          </button>
          {!hard && (
            <button
              className="btn"
              onClick={dismissSoft}
              style={{ background: 'transparent', border: '1px solid var(--hairline)', color: 'var(--ink-muted)' }}
            >
              {t('update.later')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
